export const UsersPreferencesLSKey = 'ms4::users_preferences';
